import "what-input";
import Vue from "vue";
import { instance } from "./api/instance.js";
import ExampleComponent from "./components/ExampleComponent.vue";
import PostsComponent from "./components/PostsComponent.vue";
import LocomotiveScroll from "locomotive-scroll";

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: "#app",
  components: {
    "example-component": ExampleComponent,

    "posts-component": PostsComponent,
  },
  mounted() {
    console.log("Running Vue.js");
  },
  data() {
    return {
      menu_active: false,
      scrollPosition: null,
    };
  },
  methods: {
    toggle_menu: function() {
      this.menu_active = !this.menu_active;
      document.querySelector(".burger").classList.toggle("burger_active");
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
});

(function($) {
  $(document).ready(function() {
    // Loaded when DOM is ready
    console.log("Running jQuery");

    if ($("[data-scroll-container]").length) {
      let scroll = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),
        smooth: true,
        lerp: 0.4,
        noParallax: {
          smooth: false,
          breakpoint: 992,
        },
      });

      setTimeout(() => {
        scroll.update();
      }, 1000);

      // $(".burger").on("click", () => {
      //   if (vue.menu_active) {
      //     scroll.stop();
      //   } else {
      //     scroll.start();
      //   }
      // });

      scroll.on("scroll", (position) => {
        // console.log("SCROLLING 2");
        $(".is-inview").addClass("stay-active");
        if (position.scroll.y >= 50) {
          $("header").addClass("change_on_scroll");
        } else {
          $("header").removeClass("change_on_scroll");
        }
      });

      var parseQueryString = function() {
        var str = window.location.search;
        var objURL = {};

        str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function(
          $0,
          $1,
          $2,
          $3
        ) {
          objURL[$1] = $3;
        });
        return objURL;
      };

      //Example how to use it:
      var params = parseQueryString();
      console.log(params["scroll"]);

      scroll.scrollTo(document.querySelector("#" + params["scroll"]), {
        offset: -120,
      });

      $(".primary-hero-button").click(function() {
        scroll.scrollTo(document.querySelector("#our-approach"), {
          offset: -120,
        });
      });
    }
  });
})(jQuery);
